/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type BriefChatSessionQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type BriefChatSessionQuery = {
    __typename: 'Query';
    messages: {
        __typename: 'BriefChatSession';
        maxMessages: number;
        messages: Array<{ __typename: 'BriefChatMessage'; role: string; content: string }>;
    };
};

export const BriefChatSessionDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BriefChatSession' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'messages' },
                        name: { kind: 'Name', value: 'briefChatSession' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'maxMessages' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useBriefChatSessionQuery__
 *
 * To run a query within a React component, call `useBriefChatSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefChatSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefChatSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefChatSessionQuery(
    baseOptions: Apollo.QueryHookOptions<BriefChatSessionQuery, BriefChatSessionQueryVariables>
) {
    return Apollo.useQuery<BriefChatSessionQuery, BriefChatSessionQueryVariables>(
        BriefChatSessionDocument,
        baseOptions
    );
}
export function useBriefChatSessionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BriefChatSessionQuery, BriefChatSessionQueryVariables>
) {
    return Apollo.useLazyQuery<BriefChatSessionQuery, BriefChatSessionQueryVariables>(
        BriefChatSessionDocument,
        baseOptions
    );
}
export type BriefChatSessionQueryHookResult = ReturnType<typeof useBriefChatSessionQuery>;
export type BriefChatSessionLazyQueryHookResult = ReturnType<typeof useBriefChatSessionLazyQuery>;
export type BriefChatSessionQueryResult = Apollo.QueryResult<
    BriefChatSessionQuery,
    BriefChatSessionQueryVariables
>;
